import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';

import { clearChat, setChat } from './actions';

export const item = createReducer({
  isExists: false,
  url: '',
  text: '',
})
  .handleAction(setChat, (_state, action) => action.payload)
  .handleAction(clearChat, (_state, _action) => {
    return {
      isExists: false,
      url: '',
      text: '',
    };
  });

const chatReducer = combineReducers({
  item,
});

export default chatReducer;
export type ChatState = ReturnType<typeof chatReducer>;
